import Presentation from "./presentation";

const DonationTabEmptyView = ( { activeTab } ) => {

	const getEmptyText = activeTab => {
		switch ( activeTab ) {
			case "ACTIVITY":
				return "Win Coins, Complete Daily Tasks, Create posts to see your activity here.";

			case "UPDATES":
				return "We don’t have any updates at the moment.";

			default:
				return "Follow streamers, Create streams, videos & reels to see notifications here.";

		}
	};

	const emptyText = getEmptyText ( activeTab );

	return (
		<Presentation
			activeTab = { activeTab }
			emptyText = { emptyText }
		/>
	);
};

export default DonationTabEmptyView;